import { Pagination as AntdPagination } from "antd";
import React, { useEffect, useState } from "react";
import { setPaginationHistory } from "utils/helpers/pagination";
import { INITIAL_VALUES } from "../../../utils/constants";

const TOP = { X: 0, Y: 0 };
const Pagination = ({
  count,
  setValues,
  skip = INITIAL_VALUES.skip,
  take = INITIAL_VALUES.take,
  scrollToTop = true,
  footprint = "",
}) => {
  const pageSize = take || INITIAL_VALUES.take;
  const [page, setPage] = useState(() => Math.floor(skip / pageSize) + 1);

  useEffect(() => {
    setPage(Math.floor(skip / pageSize) + 1);
  }, [skip, pageSize]);

  const onChange = (value) => {
    scrollToTop && window.scrollTo(TOP.X, TOP.Y);
    setPage(value);
    footprint &&
      setPaginationHistory({ footprint, value, take: pageSize, count });
    setValues((prev) => ({
      ...prev,
      skip: (value - 1) * pageSize,
      take: pageSize,
    }));
  };
  return (
    <AntdPagination
      onChange={onChange}
      current={page}
      total={count}
      showSizeChanger={false}
      pageSize={pageSize}
    />
  );
};

export default React.memo(Pagination);
